/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerInsurancesInner } from './IntegrationEventPccPatientLeadsInnerInsurancesInner';
import {
    IntegrationEventPccPatientLeadsInnerInsurancesInnerFromJSON,
    IntegrationEventPccPatientLeadsInnerInsurancesInnerFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerInsurancesInnerToJSON,
    IntegrationEventPccPatientLeadsInnerInsurancesInnerToJSONTyped,
} from './IntegrationEventPccPatientLeadsInnerInsurancesInner';
import type { LeadAdmissionStatusInfo } from './LeadAdmissionStatusInfo';
import {
    LeadAdmissionStatusInfoFromJSON,
    LeadAdmissionStatusInfoFromJSONTyped,
    LeadAdmissionStatusInfoToJSON,
    LeadAdmissionStatusInfoToJSONTyped,
} from './LeadAdmissionStatusInfo';
import type { IntegrationEventPccPatientLeadsInnerOccupanciesInner } from './IntegrationEventPccPatientLeadsInnerOccupanciesInner';
import {
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerToJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerToJSONTyped,
} from './IntegrationEventPccPatientLeadsInnerOccupanciesInner';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInner
 */
export interface IntegrationEventPccPatientLeadsInner {
    /**
     * 
     */
    leadId?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    admission_status?: IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum;
    /**
     * 
     */
    admission_status_info?: LeadAdmissionStatusInfo;
    /**
     * 
     */
    crmEventLogs?: Array<object>;
    /**
     * 
     */
    occupancies?: Array<IntegrationEventPccPatientLeadsInnerOccupanciesInner>;
    /**
     * 
     */
    insurances?: Array<IntegrationEventPccPatientLeadsInnerInsurancesInner>;
}


/**
 * @export
 */
export const IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum = {
    Booked: 'Booked',
    MovedIn: 'Moved-In',
    MovedOut: 'Moved-Out',
    Lost: 'Lost',
    Hospitalized: 'Hospitalized',
    Loa: 'LOA',
} as const;
export type IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum = typeof IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum[keyof typeof IntegrationEventPccPatientLeadsInnerAdmissionStatusEnum];


/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInner interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInner(value: object): value is IntegrationEventPccPatientLeadsInner {
    return true;
}

export function IntegrationEventPccPatientLeadsInnerFromJSON(json: any): IntegrationEventPccPatientLeadsInner {
    return IntegrationEventPccPatientLeadsInnerFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'leadId': json['leadId'] == null ? undefined : json['leadId'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'admission_status': json['admission_status'] == null ? undefined : json['admission_status'],
        'admission_status_info': json['admission_status_info'] == null ? undefined : LeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
        'crmEventLogs': json['crmEventLogs'] == null ? undefined : json['crmEventLogs'],
        'occupancies': json['occupancies'] == null ? undefined : ((json['occupancies'] as Array<any>).map(IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSON)),
        'insurances': json['insurances'] == null ? undefined : ((json['insurances'] as Array<any>).map(IntegrationEventPccPatientLeadsInnerInsurancesInnerFromJSON)),
    };
}

export function IntegrationEventPccPatientLeadsInnerToJSON(json: any): IntegrationEventPccPatientLeadsInner {
    return IntegrationEventPccPatientLeadsInnerToJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerToJSONTyped(value?: IntegrationEventPccPatientLeadsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leadId': value['leadId'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'admission_status': value['admission_status'],
        'admission_status_info': LeadAdmissionStatusInfoToJSON(value['admission_status_info']),
        'crmEventLogs': value['crmEventLogs'],
        'occupancies': value['occupancies'] == null ? undefined : ((value['occupancies'] as Array<any>).map(IntegrationEventPccPatientLeadsInnerOccupanciesInnerToJSON)),
        'insurances': value['insurances'] == null ? undefined : ((value['insurances'] as Array<any>).map(IntegrationEventPccPatientLeadsInnerInsurancesInnerToJSON)),
    };
}

